import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';

/**
    * Retrieves data from specified URL using HTTP.
     */
@Injectable()
export class ServiceFactory {

  constructor(private http: Http) { }

  public getResponse(path: string): Observable<Response> {
    return this.http.get(path);
    // .map(mapMenu)
    //  .catch((error:any) => Observable.throw( 'Server error'));

  }

}
